import gql from 'graphql-tag';

export const getProfileVisibilityOptions = gql`
  query GetProfileVisibilityOptions($locale: Locale!, $zone: Zone!) {
    profileVisibilityOptions {
      id
      label: name(locale: $locale)
      description(locale: $locale, zone: $zone)
      __typename
    }
  }
`;

export const getProfileVisibility2 = gql`
  query GetProfileVisibility2($locale: Locale!) {
    viewer {
      _id
      id
      profileVisibility2 {
        __typename
        id
        label: name(locale: $locale)
      }
    }
  }
`;

export const updateProfileVisibility2Mutation = gql`
  mutation UpdateProfileVisibility2(
    $input: UpdateProfileVisibility2Input!
    $locale: Locale!
  ) {
    updateProfileVisibility2(input: $input) {
      __typename
      ... on UpdateProfileVisibility2Success {
        __typename
        viewer {
          _id
          id
          profileVisibility2 {
            __typename
            id
            label: name(locale: $locale)
          }
        }
      }
      ... on UpdateProfileVisibility2Failure {
        __typename
        error {
          __typename
          message(locale: "en-AU")
        }
      }
    }
  }
`;

export const getApproachability = gql`
  query GetApproachability {
    viewer {
      _id
      id
      approachability {
        approachable
      }
    }
  }
`;

export const updateApproachabilityMutation = gql`
  mutation UpdateApproachability($input: UpdateApproachabilityInput!) {
    updateApproachability(input: $input) {
      viewer {
        _id
        id
        approachability {
          approachable
        }
      }
    }
  }
`;
